<template>
  <div class="page">
    <CContainer>
      <div class="header-bar">
        <CButton class="back-btn" aria-label="Go back" @click="$router.go(-1)">
          <svg viewBox="0 0 24 24" class="icon-back">
            <line x1="19" y1="12" x2="5" y2="12" />
            <polyline points="12 19 5 12 12 5" />
          </svg>
        </CButton>
        <h2 class="center-title">Contact Support</h2>
      </div>

      <h4 class="section-title">FAQ’s</h4>
      <div class="faq-grid">
        <button v-for="item in faqItems" :key="item.label" class="faq-card">
          <img :src="item.icon" class="faq-icon" />
          <span class="faq-text">{{ item.label }}</span>
        </button>
      </div>

      <h4 class="section-title mt">Contact Us</h4>
      <button class="contact-row" @click="mailto">
        <div class="row-left">
          <img :src="emailIcon" class="contact-icon" />
          <div class="row-copy">
            <div class="row-title">Email</div>
            <div class="row-sub">customersupport@gmail.com</div>
          </div>
        </div>
        <span class="chev"></span>
      </button>

      <button class="contact-row" @click="tel">
        <div class="row-left">
          <img :src="phoneIcon" class="contact-icon" />
          <div class="row-copy">
            <div class="row-title">Phone Number</div>
            <div class="row-sub">019 2077225</div>
          </div>
        </div>
        <span class="chev"></span>
      </button>

      <a
  class="contact-row"
  href="https://api.whatsapp.com/send?phone=600192077225&text=Hi%20Surpriz.ing%2C%20I%20want%20to%20ask..."
  target="_blank"
  rel="noopener noreferrer"
>
  <div class="row-left">
    <img :src="whatsappIcon" class="contact-icon" />
    <div class="row-copy">
      <div class="row-title">Contact Support</div>
      <div class="row-sub">(60) 0192077225</div>
    </div>
  </div>
  <span class="chev"></span>
</a>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "ContactSupport",
  data() {
    return {
      faqItems: [
        { label: "Getting Started", icon: require("@/assets/img/new/group.png") },
        { label: "My Account", icon: require("@/assets/img/new/Icon.png") },
        { label: "Technical Issues", icon: require("@/assets/img/new/technical.png") },
        { label: "Security and Privacy", icon: require("@/assets/img/new/password.png") },
      ],
      emailIcon: require("@/assets/img/new/email.png"),
      phoneIcon: require("@/assets/img/new/phone.png"),
      whatsappIcon: require("@/assets/img/toggle-chat.png"),
    };
  },
  methods: {
    mailto() {
      window.location.href = "mailto:customersupport@gmail.com";
    },
    tel() {
      window.location.href = "tel:+18085550111";
    },
  },
};
</script>

<style scoped>
.page{background:#fff;min-height:100vh;padding-bottom:24px}
.header-bar{position:relative;height:75px;margin-bottom:8px}
.back-btn{position:absolute;left:4px;top:50%;transform:translateY(-50%);width:44px;height:44px;display:grid;place-items:center;background:transparent;border:0;color:#111827;cursor:pointer}
.icon-back{width:22px;height:22px;stroke:currentColor;fill:none;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round}
.center-title{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);margin:0;font-size:18px;font-weight:600;color:#111827}
.section-title{font-size:16px;font-weight:500;color:#171717;margin:22px 0 22px}
.section-title.mt{margin-top:18px}
.faq-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px}
.faq-card{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;height:180px;border-radius:14px;background:#f5f7fa;border:1px solid #eef0f4;width:100%}
.faq-icon{width:40px;height:40px}
.faq-text{font-size:14px;font-weight:600;color:#171717}
.contact-row{width:100%;display:flex;align-items:center;justify-content:space-between;background:#f3f4f6;border:1px solid #e7e9ee;border-radius:16px;padding:12px 14px;margin-top:10px}
.row-left{display:flex;align-items:center;gap:10px}
.contact-icon{width:24px;height:24px}
.row-copy{display:flex;flex-direction:column;align-items:flex-start}
.row-title{font-size:14px;font-weight:700;color:#171717}
.row-sub{font-size:12px;color:#8a8f98}
.chev{width:18px;height:18px;background:#111827;-webkit-mask:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><polyline points='9 6 15 12 9 18' fill='none' stroke='%23111827' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'/></svg>") no-repeat center/contain;mask:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><polyline points='9 6 15 12 9 18' fill='none' stroke='%23111827' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'/></svg>") no-repeat center/contain}
</style>
